import { IFilterItem } from '@cbridge-tools/filters-panel';
import { compareSymbolGroups } from '@cbridge-utils/object';

export function buildSymbolGroupsTree(paths: string[]): IFilterItem[] {
  const root: IFilterItem[] = [];
  const sorted = [...paths].sort(compareSymbolGroups);

  for (const path of sorted) {
    const segments = path.split('/');
    let currentLevel = root;
    let fullPath = '';

    const appendSegment = (segment: string) => {
      return fullPath ? `${fullPath}/${segment}` : segment;
    };

    for (let i = 0; i < segments.length; i++) {
      const segment = segments[i];

      fullPath = appendSegment(segment);

      let node = currentLevel.find((n) => n.label === segment);
      if (!node) {
        node = {
          label: segment,
          value: fullPath,
        };
        currentLevel.push(node);
      }

      if (i < segments.length - 1) {
        if (!node.nested) {
          node.nested = [];
        }
        currentLevel = node.nested;
      }
    }
  }

  return root;
}
